import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <div className="footer">
      <Link to="/gospeldownloads">
        <p className="canvas">gd 2021</p>
      </Link>
    </div>
  );
};
